export const theme = {
  token: {
    colorPrimary: '#00a17b',
    colorInfo: '#0078f6',
    colorSuccess: '#309536',
    colorError: '#f53020',
    colorWarning: '#e97500',
    colorTextBase: '#222726',
    colorLink: '#00a17b',
    borderRadius: 8,
    wireframe: false,
    fontSize: 16,
    fontFamily:
      '"Sans Serif", "Roboto", -apple-system, BlinkMacSystemFont, "Meiryo", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro", "Yu Gothic UI", "MS PGothic", Arial, sans-serif'
  },
  components: {
    Button: {
      controlHeight: 40,
      contentFontSize: 16,
      controlHeightSM: 28,
      controlHeightLG: 30,
      controlOutline: 'rgba(0,0,0,0)',
      paddingInline: 38
    },
    Input: {
      borderRadius: 8,
      controlHeight: 40
    },
    InputNumber: {
      borderRadius: 8,
      controlHeight: 40
    },
    Checkbox: {
      controlInteractiveSize: 16,
      borderRadiusSM: 4
    },
    Menu: {
      itemBorderRadius: 100,
      subMenuItemBg: 'rgb(226, 246, 239)',
      controlItemBgActive: 'rgba(130, 217, 193, 0.5)',
      itemHoverBg: 'rgba(130, 217, 193, 0.5)',
      iconMarginInlineEnd: 16,
      itemHeight: 48,
      itemMarginInline: 0,
      itemMarginBlock: 0,
      iconSize: 24,
      colorText: 'rgb(70, 78, 77)',
      fontSize: 14
    },
    Table: {
      borderColor: 'rgb(245, 245, 245)',
      headerBg: 'rgb(226, 246, 239)',
      headerColor: 'rgb(34, 39, 38)',
      rowHoverBg: 'rgb(226, 246, 239)',
      fontSize: 14,
      cellPaddingInline: 24,
      cellPaddingInlineMD: 24
    },
    Pagination: {
      itemActiveBg: 'rgb(0, 161, 123)',
      colorPrimary: 'rgb(255, 255, 255)',
      colorPrimaryHover: 'rgb(255, 255, 255)',
      colorBgTextHover: 'rgba(226, 246, 239, 0.5)',
      itemSize: 40
    },
    Modal: {
      colorBgMask: 'rgba(22, 22, 26, 0.6)',
      borderRadiusLG: 28,
      boxShadow: '0px 16px 16px 0px rgba(0, 0, 0, 0.02)'
    },
    Radio: {
      wrapperMarginInlineEnd: 64
    },
    Segmented: {
      itemSelectedColor: 'rgb(0, 161, 123)',
      itemColor: 'rgb(107, 117, 115)'
    }
  }
};
